import * as React from "react";
import { WebsocketContext } from "./WebsocketProvider";
import { useTranslation } from "./i18n";
/*
 * Lobby control to add / remove AI players (Milestone 1 protocol).
 *
 * Dispatches over the SAME websocket `send` mechanism every other lobby action
 * uses (see Players.tsx / Initialize.tsx), wrapping the action in { Action: ... }:
 *   - Add:    { Action: { AddAIPlayer: { difficulty } } }
 *   - Remove: { Action: { RemoveAIPlayer: playerId } }
 */
var DIFFICULTIES = [
    "Easy",
    "Expert",
    "Enoch",
    "Grandmaster",
    "Omniscient",
];
var AddAIPlayer = function () {
    var send = React.useContext(WebsocketContext).send;
    var t = useTranslation().t;
    var _a = React.useState("Expert"), difficulty = _a[0], setDifficulty = _a[1];
    var addBot = function () {
        send({ Action: { AddAIPlayer: { difficulty: difficulty } } });
    };
    return (React.createElement("div", { className: "sj-rail mb-4 flex flex-wrap items-center gap-3 p-3" },
        React.createElement("span", { className: "text-sm font-semibold", "aria-hidden": "true" },
            "\uD83E\uDD16 ",
            t("ai.heading")),
        React.createElement("label", { className: "flex items-center gap-2 text-sm" },
            React.createElement("span", { className: "text-[var(--text-secondary)]" }, t("ai.difficulty")),
            React.createElement("select", { className: "sj-input !min-h-[40px] !py-1", value: difficulty, onChange: function (e) { return setDifficulty(e.target.value); }, "aria-label": t("ai.difficulty") }, DIFFICULTIES.map(function (d) { return (React.createElement("option", { key: d, value: d }, t("ai.difficulty.".concat(d)))); }))),
        React.createElement("button", { type: "button", className: "sj-btn sj-btn-primary", onClick: addBot },
            "+ ",
            t("ai.add")),
        difficulty === "Omniscient" && (React.createElement("span", { className: "text-sm font-semibold text-[#b91c1c]", role: "status" },
            "\u26A0 ",
            t("ai.omniscientWarning")))));
};
export default AddAIPlayer;
